export default "__VITE_ASSET__8de89b51__"